module.exports = __webpack_public_path__ + "assets/img/btn_pc-f4e76dee.png";